import * as tinycolor from 'tinycolor2';

import { getColor } from '../color';

const UserPresence = {};

const addName = (id, name, color) => {
  const highlightingColor = tinycolor(color)
    .setAlpha(0.3)
    .toString();

  const styleTag = document.createElement('style');
  styleTag.id = `style-${id}`;
  styleTag.innerHTML = `
    .u-${id} { background-color: ${color}; }
    .CodeMirror-line .u-${id}                   { background-color: ${highlightingColor}; }
    .CodeMirror-line .u-${id}.cursor            { opacity: 1; }
    .CodeMirror-line .u-${id}.cursor.left       { border-left: 2px solid ${color}; }
    .CodeMirror-line .u-${id}.cursor.right      { border-right: 2px solid ${color}; }
    .CodeMirror-line .u-${id}.empty             { background-color: transparent; }
    .code-cursor-flag .u-${id} { background-color: ${color}; }
    .code-cursor-caret .u-${id} { background-color: ${color}; }
`;
  document.querySelector('head').appendChild(styleTag);
};

// For every time there is a presence update, check the list of users, and if
// they haven't already had a CSS class set, look up the correct color and set
// the CSS styles for them. This is triggered by the CodeHeader, so it will
// start for all code SLEDs/Minerva Notebooks. Because these styles are
// required for all the different code cells, it seems more efficient to make
// it global.
export const initializeCodePresence = (doc) => {
  doc.on('presence', (srcList) =>
    srcList.forEach((src) => {
      const presence = doc.presence[src];
      if (presence && presence.s && presence.s.u) {
        const userId = presence.s.u;
        if (!UserPresence[userId] && doc.data.users[userId]) {
          addName(userId, doc.data.users[userId].name, getColor(userId));
          UserPresence[userId] = true;
        }
      }
    })
  );
};
